export const maskAccountNumber = (num: string) =>
  num.length > 4 ? `****${num.slice(-4)}` : num;
